import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
/* eslint-disable ember/no-computed-properties-in-native-classes */
/* eslint-disable ember/no-runloop */
import { action, computed, set } from '@ember/object';
import { cancel, debounce } from '@ember/runloop';
import dayjs from 'dayjs';
import PowerCalendarRangeDays from 'ember-power-calendar/components/power-calendar-range/days';
import emberPowerCalendarDayClassesCustom from 'lumen/helpers/ember-power-calendar-day-classes-custom';

/*
Custom day component so that we don't need to fork ember-power-calendar

small modifications to change the hover behaviour when selecting a range:
- added mouseEnter action handler in the days template
- extra check in buildDay function to allow new hover behaviour

original components:
- https://github.com/cibernox/ember-power-calendar/blob/master/addon/components/power-calendar/days.js
- https://github.com/cibernox/ember-power-calendar/blob/master/addon/components/power-calendar-range/days.js
*/

export default class GeneralCalendarsDaysEmberPowerCalendarCustomDay extends PowerCalendarRangeDays {
  debouncedHoverAction = null;

  // Added to determine if this needs to be styled as hover
  hoveredRange = null;

  @computed('showDaysAround', 'day', 'args.hoveredRange.{start,end}')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get weeks() {
    const { showDaysAround, days } = this;
    const weeks = [];
    let i = 0;
    while (days[i]) {
      let daysOfWeek = days.slice(i, i + 7);
      if (!showDaysAround) {
        daysOfWeek = daysOfWeek.filter((d) => d.isCurrentMonth);
      }

      // Custom logic
      daysOfWeek.forEach((day) => {
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (day.moment && !day.isSelected && this.args.hoveredRange?.start) {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
          day.isDayInHoveredRange = day.moment.isBetween(
            // @ts-expect-error: Incorrect type
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            this.args.hoveredRange?.start,
            // @ts-expect-error: Incorrect type
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            this.args.hoveredRange?.end,
            'day',
            '[]',
          );
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
          day.isRangeStart = day.moment.isSame(
            // @ts-expect-error: Incorrect type
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            this.args.hoveredRange?.start,
            'day',
          );
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
          day.isRangeEnd = day.moment.isSame(
            // @ts-expect-error: Incorrect type
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            this.args.hoveredRange?.end,
            'day',
          );
        } else if (!day.isSelected) {
          // @ts-expect-error: Incorrect type
          // Properly clear hover selection when hoveredRange is null (but don't clear selection though)
          day.isDayInHoveredRange = false;
          day.isRangeStart = false;
          day.isRangeEnd = false;
        }
      });

      weeks.push({
        // @ts-expect-error: Incorrect type
        id: `week-of-${daysOfWeek[0].id}`,
        days: daysOfWeek,
        missingDays: 7 - daysOfWeek.length,
      });
      i += 7;
    }
    return weeks;
  }

  willDestroy(): void {
    super.willDestroy();

    if (this.debouncedHoverAction) {
      cancel(this.debouncedHoverAction);
      set(this, 'debouncedHoverAction', null);
    }
  }

  // @ts-expect-error: Incorrect type
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  buildDay(date, today, calendar) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const dateMoment = dayjs(date);
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line prefer-rest-params
    const day = super.buildDay(...arguments);

    // Use dayjs instead of PowerCalendar's moment
    day.moment = dateMoment;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const { start, end } = calendar.selected || { start: null, end: null };
    if (start && end) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-argument
      day.isSelected = dateMoment.isBetween(start, end, 'day', '[]');
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      day.isRangeStart = day.isSelected && dateMoment.isSame(start, 'day');
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      day.isRangeEnd = day.isSelected && dateMoment.isSame(end, 'day');
    } else {
      day.isRangeEnd = false;
      if (!start) {
        day.isRangeStart = false;
      } else {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        day.isRangeStart = day.isSelected = dateMoment.isSame(start, 'day');

        // Custom extra check
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        if (day.moment.isBetween(day, start, this.args.hoveredDayMoment)) {
          day.isSelected = true;
        }

        if (!day.isDisabled) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          const diffInMs = Math.abs(dayjs(day.date).diff(start));
          day.isDisabled =
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (diffInMs < calendar.minRange || calendar.maxRange !== null) &&
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            diffInMs > calendar.maxRange;
        }
      }
    }
    return day;
  }

  // @ts-expect-error: Incorrect type

  updateHovered(day): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.args.highlightPeriod?.(day);
  }

  @action
  // @ts-expect-error: Incorrect type
  handleClick(e): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    const dayEl = e.target.closest('[data-date]');
    if (dayEl) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      const dateStr = dayEl.dataset.date;
      const day = this.days.find((d) => d.id === dateStr);
      if (day && !day.isDisabled) {
        // Custom line
        if (this.args.calendar.actions.select) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          this.args.calendar.actions.select(day, this.args.calendar, e);
        }
      }
    }
  }

  @action
  // @ts-expect-error: Incorrect type
  onMouseEnterDay(day): void {
    set(
      this,
      'debouncedHoverAction',
      // eslint-disable-next-line @typescript-eslint/unbound-method
      debounce(this, this.updateHovered, day, 85),
    );
  }

  <template>
    {{! template-lint-disable no-invalid-interactive }}
    <div
      class="ember-power-calendar-days"
      data-power-calendar-id={{@calendar.uniqueId}}
      {{on "click" this.handleClick}}
      ...attributes
    >
      <div class="ember-power-calendar-row ember-power-calendar-weekdays">
        {{#each this.weekdaysNames as |wdn|}}
          <div class="ember-power-calendar-weekday">
            {{wdn}}
          </div>
        {{/each}}
      </div>
      <div
        class="ember-power-calendar-day-grid"
        {{on "keydown" this.handleKeyDown}}
      >
        {{#each this.weeks key="id" as |week|}}
          <div
            class="ember-power-calendar-row ember-power-calendar-week"
            data-missing-days={{week.missingDays}}
          >
            {{#each week.days key="id" as |day|}}
              <button
                class={{emberPowerCalendarDayClassesCustom
                  day
                  @calendar
                  this.weeks
                  @dayClass
                }}
                data-date={{day.id}}
                disabled={{day.isDisabled}}
                type="button"
                {{on "blur" this.handleDayBlur}}
                {{on "focus" this.handleDayFocus}}
                {{on "mouseenter" (fn this.onMouseEnterDay day)}}
              >
                {{#if (has-block)}}
                  {{yield day @calendar this.weeks}}
                {{else}}
                  {{day.number}}
                {{/if}}
              </button>
            {{/each}}
          </div>
        {{/each}}
      </div>
    </div>
  </template>
}
